var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetBanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_285_218)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 36H34M16 25H34M17 23L25 18L33 23M17 25V36M33 25V36M21 29V32M25 29V32M29 29V32",
    stroke: "#183883",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 23H35.0035M34.0575 22.0573C34.3075 21.8074 34.6466 21.6669 35.0001 21.6669C35.3537 21.6669 35.6928 21.8074 35.9428 22.0573M33.1144 21.1143C33.362 20.8667 33.656 20.6702 33.9796 20.5362C34.3031 20.4022 34.6499 20.3332 35.0001 20.3332C35.3503 20.3332 35.6971 20.4022 36.0206 20.5362C36.3442 20.6702 36.6381 20.8667 36.8858 21.1143M32.1719 20.1717C33.7339 18.6093 36.2665 18.6093 37.8385 20.1717",
    stroke: "#183883",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_285_218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetBanking);
export default __webpack_public_path__ + "static/media/NetBanking.a5e47d7e57c7d54ae4e92960df26b419.svg";
export { ForwardRef as ReactComponent };